module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.6.2 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support radio mode(max = 1) #1996")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] scroll distance respects html[data-dpr] #1979")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] update address data #2000")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7ac6b8f8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-7ac6b8f8"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.6.2-126.vue
// module id = 2358
// module chunks = 261